import React from 'react';
import PropTypes from 'prop-types';

import CourseName from '../../../../CourseName/CourseName';
import { useLocation, useNavigate } from 'react-router-dom';
import ButtonIcon from '../../../../../common/ButtonIcon/ButtonIcon';
import VocabularyButton from '../../../../../common/VocabularyButton/VocabularyButton';
import Progress from '../../../../Progress/Progress';
import ProgramsLink from '../../ProgramsLink/ProgramsLink';

import { homeworkColors } from '../../../../schedule/constants';
import CertificateButton from '../../../../Certificates/CertificateButton';

const ProgramsTableRow = ({ course }) => {
  const lastLesson = course?.last_lesson ?? null;
  const navigate = useNavigate();
  const location = useLocation();

  const setHomeworkPage = () => {
    if (!lastLesson) return;
    localStorage.setItem('event', JSON.stringify(lastLesson));
    localStorage.setItem('eventId', JSON.stringify(lastLesson?.event_id ?? null));
    localStorage.setItem('realHomeworkId', JSON.stringify(lastLesson?.homework_id ?? null));
    navigate('/homework', { state: { from: location.pathname } });
  };

  const setLink = (link) => {
    if (!link) return;
    window.open(link, '_blank');
  };

  // Безпечні дефолти для кольору і анімації
  const homeworkColorIdx = Number.isInteger(lastLesson?.homework_icon_color)
    ? lastLesson.homework_icon_color
    : 4; // 4 — нейтральний стан
  const hex = homeworkColors?.[homeworkColorIdx];
  const shouldPulse = !!lastLesson && homeworkColorIdx !== 4;
  const pulseStyle = shouldPulse && hex ? { '--pulse-color': hex } : undefined;

  return (
    <tr className='table-body__row'>
      <td className='table-body__cell'>
        <CourseName
          img={course?.image}
          name={course?.direction_name}
          level={course?.program_name}
          isViolet={true}
        />
      </td>

      <td className='table-body__cell table-body__cell--center'>
        {/* Рендеримо матеріали лише якщо lastLesson існує */}
        {lastLesson && (
          <div className="program-item__btns">
            {lastLesson?.presentation_link && (
              <ButtonIcon
                classes='program-item__btn'
                icon='monitor'
                btnBg='white'
                iconColor='green'
                btnSize='lg'
                iconSize='md'
                onClick={() => setLink(lastLesson.presentation_link)}
              />
            )}
            {lastLesson?.google_pdf_url && (
              <ButtonIcon
                classes='program-item__btn'
                icon='pdf'
                btnBg='white'
                iconColor='green'
                btnSize='lg'
                iconSize='md'
                onClick={() => setLink(lastLesson.google_pdf_url)}
              />
            )}

            {lastLesson?.youtube_link && (
              <ButtonIcon
                classes='program-item__btn'
                icon='youtube'
                btnBg='white'
                iconColor='green'
                btnSize='lg'
                iconSize='md'
                onClick={() => setLink(lastLesson.youtube_link)}
              />
            )}

            {lastLesson?.vocabulary_link && (
              <ButtonIcon
                classes='program-item__btn'
                icon='list'
                btnBg='white'
                iconColor='green'
                btnSize='lg'
                iconSize='md'
                onClick={() => setLink(lastLesson.vocabulary_link)}
              />
            )}

            <VocabularyButton classes='program-item__btn' token={lastLesson?.vocabulary_token} />

            {lastLesson?.video_url && (
              <ButtonIcon
                classes='program-item__btn'
                icon='video'
                btnBg='white'
                iconColor='green'
                btnSize='lg'
                iconSize='md'
                onClick={() => setLink(lastLesson.video_url)}
              />
            )}

            {lastLesson?.is_show_homework && (
              <div className="homework-icon-wrapper">
                {lastLesson?.is_show_icon_new && (
                  <div className="new-badge">new</div>
                )}
                <ButtonIcon
                  classes={`program-item__btn ${shouldPulse ? 'pulsing-icon' : ''}`}
                  icon='book'
                  btnBg='white'
                  iconColor={homeworkColors?.[homeworkColorIdx]}
                  btnSize='lg'
                  iconSize='md'
                  onClick={setHomeworkPage}
                  style={pulseStyle}
                />
              </div>
            )}
          </div>
        )}
      </td>

      <td className='table-body__cell table-body__cell--center'>
        <ProgramsLink
          count={course?.event_lesson_count ?? 0}
          link='/course/program'
          onClick={() => localStorage.setItem('programId', JSON.stringify(course?.program_id ?? null))}
        />
      </td>

      <td className='table-body__cell table-body__cell--center'>
        {course?.study_lesson_count ?? 0}
      </td>

      <td className='table-body__cell table-body__cell--center'>
        <Progress progress={course?.lesson_persent ?? 0} />
      </td>

      <td className='table-body__cell table-body__cell--center'>
        <CertificateButton
          programId={course?.program_id}
          programTitle={course?.direction_name}
        />
      </td>
    </tr>
  );
};

ProgramsTableRow.propTypes = {
  course: PropTypes.object.isRequired,
};

export default ProgramsTableRow;